const Constants = {
  ENVIRONMENT: {
    DEV: 'dev',
    STAGING: 'staging',
    PROD: 'prod'
  },
  IMAGE_SIZE: {
    VGA: '640x480',
    HD: '1280x780',
    FHD: '1920x1080',
    LOW: '320x240',
    ORI: '3840x2160' //4K
  },
  COMPRESS_QUALITY: {
    LOW: 95,
    VGA: 90,
    HD: 90,
    FHD: 93,
    ORI: 90
  }
};

const SHARD_ID = {
  REPORT: 'SHARD_REPORT',
  ACTIVITY: 'SHARD_ACTIVITY'
};

/**
 * The states the landing form can be in.
 *
 * `email-sent` and `verified` used to live here too, for a phone-OTP sign-up
 * that dispatched them on its way to a set-password screen. The revamp removed
 * that flow and the screen it fed, and members nothing sets are worse than
 * absent: every branch keyed on one reads as live code that simply never runs.
 */
enum AUTH_MODE {
  SIGN_UP = 'signup',
  LOGIN = 'login',
  RESET_PASSWORD = 'resetpassword'
}
const UPLOAD_CONFIG = {
  MAX_CONCURRENT: 2,
  MAX_RETRY: 3
};

export { Constants, SHARD_ID, AUTH_MODE, UPLOAD_CONFIG };
